import React from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { useDispatch } from "react-redux";
import { ChangeOrderStatusAction, releaseDelayedSlot, releaseAllDelayedSlots } from "../../redux/actions/OrdersAction";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { confirmPopup } from "primereact/confirmpopup";

export default function OrdersTable({
  latestOrders,
  completedOrders,
  locationId,
  formattedTime,
  getColor,
  getStyle,
  getDelayInfo,
}) {
  const dispatch = useDispatch();

  const handleCheck = (id, status) => {
    dispatch(ChangeOrderStatusAction(id, locationId, status));
  };

  const handleReleaseSlot = (orderId, time) => {
    dispatch(releaseDelayedSlot(orderId, time, locationId));
  };

  const confirmReleaseAll = (event, orderId) => {
    confirmPopup({
      target: event.currentTarget,
      message: "Free all delayed slots for this order?",
      icon: "pi pi-exclamation-triangle",
      accept: () => dispatch(releaseAllDelayedSlots(orderId, locationId)),
      reject: () => {},
    });
  };

  const switchTemplate = (rowData) => {
    return (
      <div className="flex justify-content-center">
        <>
          <i
            className="pi text-green-500 pi-check-circle mx-2 cursor-pointer text-3xl"
            onClick={() => handleCheck(rowData?._id, "READY")}
          ></i>
        </>
      </div>
    );
  };

  const addOns = (rowData) => {
    const items = rowData?.selectedAddOns.map((item, i) => (
      <span className="text-green-500">
        {i ? "," : ""} {item?.name}
      </span>
    ));
    return items;
  };
  const Ingredients = (rowData) => {
    const items = rowData?.removedIngredients.map((item, i) => (
      <span className="text-red-500">
        {i ? "," : ""} {item?.name}
      </span>
    ));
    return items;
  };

  const time = (rowData) => {
    return <>{rowData?.pickupTime}</>;
  };

  const statusBodyTemplate = (data) => {
    return <Tag value={data.status} severity={getSeverity(data.status)}></Tag>;
  };

  const getSeverity = (status) => {
    switch (status) {
      case "READY":
        return "success";
      case "CANCELED":
        return "danger";
      default:
        return "success";
    }
  };

  const getPrice = (price) => {
    return parseFloat(price).toFixed(2);
  };

  const paymentStatus = (item) => {
    if (!item.invoiceId) return "";
    const iconMap = {
      MOBILE: { icon: "📱", label: "Mobile" },
      CASH:   { icon: "💰", label: "Cash" },
      CARD:   { icon: "💳", label: "Card" },
    };
    const p = iconMap[item.paymentIcon] || iconMap.CARD;
    return <>{p.icon} {p.label}</>;
  };

  return (
    <>
      {formattedTime}
      <TableCard title="Latest Orders">
        <div className="grid surface-ground font-bold p-2 largescreen-text">
          <div className="col-2">Zeit</div>
          {/* <div className="col-1">Source</div> */}
          <div className="col-6 m-0">
            <div className="grid">
              <div className="col-1">X</div>
              <div className="col-5">Produkt</div>
              <div className="col-6">Ohne/Extra</div>
            </div>
          </div>
          <div className="col-1">Preise</div>
          <div className="col-1">ZahlSt</div>
          <div className="col-2 text-center">Status</div>
        </div>

        {latestOrders.map((order) => {
          const delayInfo = getDelayInfo(order);
          return (
            <React.Fragment key={order._id}>
              <div
                className={`grid p-2 border-1 mb-3  ${getColor(
                  order
                )}  shadow-1 largescreen-text`}
                style={getStyle(order)}
              >
                <div className="col-2 font-bold">{time(order)}</div>
                {/* <div className="col-1">
                  {order?.source === "MOBILE"
                    ? order?.status === "READY"
                      ? "Pickup"
                      : "Awaiting"
                    : ""}
                </div> */}
                <div className="col-6 m-0">
                  {order?.cart?.cartItems
                    .filter((item) => !item?.isDepositItem)
                    .map((item, i) => (
                      <div className="grid">
                        <div className="col-1 font-semibold">{item?.qty}</div>
                        <div className="col-5 font-medium">
                          {item?.product?.name}
                        </div>

                        <div className="col-6 font-medium">
                          {Ingredients(item)}
                          {addOns(item)}
                        </div>
                      </div>
                    ))}
                </div>
                <div className="col-1 font-medium">
                  € {getPrice(order?.cart?.cartGrandTotal)}
                </div>
                <div className="col-1">{paymentStatus(order)}</div>
                <div className="col-2">{switchTemplate(order)}</div>
              </div>
              {delayInfo && (
                <div className="mb-3">
                  {delayInfo.bufferRange && (
                    <div className="flex p-1 border-1 mb-1 bg-yellow-100 border-yellow-400 shadow-1 text-sm">
                      <div className="col-1 font-bold">BUFFER TIME</div>
                      <div className="col-1">{delayInfo.bufferRange}</div>
                    </div>
                  )}
                  {delayInfo.blockedSlots.map((time) => (
                    <div
                      key={`blocked-${order._id}-${time}`}
                      className="flex p-1 border-1 mb-1 bg-pink-100 border-pink-400 shadow-1 text-sm align-items-center"
                    >
                      <div className="col-1" />
                      <div className="col-1 font-bold">{time}</div>
                      <div className="col">
                        <i className="pi pi-clock text-red-500 mr-2"></i>
                        <span className="text-red-500 font-semibold">BLOCKED</span>
                      </div>
                    </div>
                  ))}
                  {delayInfo.freedSlots.map((time) => (
                    <div
                      key={`freed-${order._id}-${time}`}
                      className="flex p-1 border-1 mb-1 bg-green-100 border-green-400 shadow-1 text-sm align-items-center"
                    >
                      <div className="col-1" />
                      <div className="col-1 font-bold">{time}</div>
                      <div className="col">
                        <i className="pi pi-check-circle text-green-500 mr-2"></i>
                        <span className="text-green-500 font-semibold">FREED</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </TableCard>
      <br />
      <TableCard title="Completed Orders">
        <div className="grid surface-ground font-bold p-2 largescreen-text">
          <div className="col-1">Zeit</div>
          <div className="col-1">Source</div>
          <div className="col-6 m-0">
            <div className="grid">
              <div className="col-1">X</div>
              <div className="col-5">Produkt</div>
              <div className="col-6">Ohne/Extra</div>
            </div>
          </div>
          <div className="col-1">Preise</div>
          <div className="col-1">ZahlSt</div>
          <div className="col-2 text-center">Status</div>
        </div>

        {completedOrders.map((order) => {
          const delayInfo = getDelayInfo(order);
          const isReady = order.status === "READY";
          return (
          <React.Fragment key={order._id}>
          <div
            className={`grid p-2 border-1 mb-3  ${getColor(
              order
            )}  shadow-1 largescreen-text`}
            style={getStyle(order)}
          >
            <div className="col-1 font-bold">{time(order)}</div>
            <div className="col-1">
              {order?.source === "MOBILE"
                ? order?.status === "READY"
                  ? "Pickup"
                  : ""
                : ""}
            </div>
            <div className="col-6 m-0">
              {order?.cart?.cartItems
                .filter((item) => !item?.isDepositItem)
                .map((item, i) => (
                  <div className="grid">
                    <div className="col-1 font-semibold">{item?.qty}</div>
                    <div className="col-5 font-medium">
                      {item?.product?.name}
                    </div>
                    <div className="col-6 font-medium">
                      {Ingredients(item)}
                      {addOns(item)}
                    </div>
                  </div>
                ))}
            </div>
            <div className="col-1 font-medium">
              € {getPrice(order?.cart?.cartGrandTotal)}
            </div>
            <div className="col-1 font-medium">{paymentStatus(order)}</div>
            <div className="col-2 text-center">{statusBodyTemplate(order)}</div>
          </div>
          {delayInfo && isReady && (
            <div className="mb-3">
              {delayInfo.bufferRange && (
                <div className="flex p-1 border-1 mb-1 bg-yellow-100 border-yellow-400 shadow-1 text-sm">
                  <div className="col-1 font-bold">BUFFER TIME</div>
                  <div className="col-1">{delayInfo.bufferRange}</div>
                </div>
              )}
              {delayInfo.blockedSlots.map((time) => (
                <div
                  key={`blocked-${order._id}-${time}`}
                  className="flex p-1 border-1 mb-1 bg-pink-100 border-pink-400 shadow-1 text-sm align-items-center"
                >
                  <div className="col-1" />
                  <div className="col-1 font-bold">{time}</div>
                  <div className="col">
                    <i className="pi pi-clock text-red-500 mr-2"></i>
                    <span className="text-red-500 font-semibold">BLOCKED</span>
                  </div>
                  <div className="col-2 text-center">
                    <span
                      className="text-blue-600 cursor-pointer hover:text-blue-800"
                      onClick={() => handleReleaseSlot(order._id, time)}
                    >
                      <i className="pi pi-lock-open mr-1"></i>Free
                    </span>
                  </div>
                </div>
              ))}
              {delayInfo.freedSlots.map((time) => (
                <div
                  key={`freed-${order._id}-${time}`}
                  className="flex p-1 border-1 mb-1 bg-green-100 border-green-400 shadow-1 text-sm align-items-center"
                >
                  <div className="col-1" />
                  <div className="col-1 font-bold">{time}</div>
                  <div className="col">
                    <i className="pi pi-check-circle text-green-500 mr-2"></i>
                    <span className="text-green-500 font-semibold">FREE</span>
                  </div>
                  <div className="col-2 text-center" />
                </div>
              ))}
              {delayInfo.blockedSlots.length > 0 && (
                <div className="flex justify-content-end mt-2">
                  <Button
                    label="Free All"
                    icon="pi pi-lock-open"
                    className="p-button-sm p-button-success"
                    onClick={(e) => confirmReleaseAll(e, order._id)}
                  />
                </div>
              )}
            </div>
          )}
          </React.Fragment>
          );
        })}
      </TableCard>
    </>
  );
}
